import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LoginInfo, SignUpData, SignUpExternalData } from 'mbs-ui-shared@models/login';
import { getObjectWithoutEmptyProp } from 'mbs-ui-shared@utils/object-to-params';

@Injectable({
  providedIn: 'root'
})
export class SignUpService {
  private http = inject(HttpClient);
  public getSignUpInfo(alias?: string) {
    return this.http.get<LoginInfo>('api/sign-up', {
      params: new HttpParams({ fromObject: getObjectWithoutEmptyProp({ alias }) })
    });
  }

  public signUp(payload: SignUpData, alias?: string) {
    return this.http.post('api/sign-up/internal', payload, {
      params: new HttpParams({ fromObject: getObjectWithoutEmptyProp({ alias }) }),
      headers: new HttpHeaders({ MANUAL_ERROR_HANDLED: 'MANUAL_ERROR_HANDLED' })
    });
  }

  public signUpByGoogle(payload: SignUpExternalData, alias?: string) {
    return this.http.post('api/sign-up/external/google', payload, {
      params: new HttpParams({ fromObject: getObjectWithoutEmptyProp({ alias }) })
    });
  }

  public signUpByMicrosoft(payload: SignUpExternalData, alias?: string) {
    return this.http.post('api/sign-up/external/microsoft', payload, {
      params: new HttpParams({ fromObject: getObjectWithoutEmptyProp({ alias }) })
    });
  }
}
